/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".happ-hover[_ngcontent-%COMP%]     .mat-list-item-content{cursor:pointer;padding:5px;border-bottom:1px solid #d4d2d2}.happ-hover[_ngcontent-%COMP%]     .mat-list-item-content:hover{background:#e6e6e6}"];
export { styles as styles };
